import React from 'react';
import { Grid } from '@mui/material';

import { SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function ErpQuotationsDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();

	return (
		<>
			{/* PRICING GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="pric_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_PRICING_GROUP')}
					value={props.model.pric_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* DISCOUNT GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="disc_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_DISCOUNT_GROUP')}
					value={props.model.disc_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT TERMS */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="pate_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_PAYMENT_TERMS')}
					value={props.model.pate_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT METHOD */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="pame_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_PAYMENT_METHOD')}
					value={props.model.pame_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* SHIPPING METHOD */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="shme_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_SHIPPING_METHOD')}
					value={props.model.shme_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* SHIPPING AGENT */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="shag_title"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_SHIPPING_AGENT')}
					value={props.model.shag_title}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* EXTERNAL NUMBER */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="quot_externalnumber"
					label={t('DETAILS_ERP_QUOTATIONS_FIELD_EXTERNAL_NUMBER')}
					value={props.model.quot_externalnumber}
					isEdit={false}
					sendChange={props.sendChange}
				/>
			</Grid>
		</>
	);
}
